export default
{
  nav: {
    'shipping-locale': 'Language',
  },
  titles: {
    default: 'Salvi Music Online Store',
    profile: 'Your account',
    orders: 'Your orders',
    addresses: 'Your addresses',
    coupons: 'Your coupons',
    configurator: 'Configurator',
    checkout: 'Checkout',
  },
  profile: {
    profile: 'My Account',
    greeting: 'Hi',
    orders: 'My Orders',
    data: 'My Data',
    addresses: 'My Addresses',
    coupons: 'Coupons',
    logout: 'Logout',
  },
  userData: {
    myData: 'MY DATA',
    complete: 'Complete your profile',
    private: 'Private',
    company: 'Company',
    birthday: 'Birthday',
    job: 'Job',
    vat: 'VAT id',
    language: 'Language',
    changeLanguage: 'Change default language',
    myHarps: 'MY HARPS',
    newHarp: 'New harp',
    addHarp: 'Add harp',
    chooseHarp: 'Choose harp',
    accessData: 'ACCESS DATA',
    save: 'Save',
    cancel: 'Cancel',
    cannotChange: 'You cannot change user type because you have orders in your name.',
    createNew: 'Create a new profile to place orders for another user type.',
    haveHarps: 'Do you have a harp or more?',
    addHarps: 'Add them here to set your configurator',
    close: 'Close',
    dateFormatPlaceholder: 'dd/mm/yyyy',
    dateFormat: 'dd/MM/yyyy',
  },
  addresses: {
    sameAs: 'Same as billing address',
    addMore: 'Add more shipping address',
    areYouSure: 'Are you sure you want to delete the address?',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit address',
    add: 'Add address',
  },
  addressForm: {
    firstname: 'Firstname',
    lastname: 'Lastname',
    co: 'C/O',
    street: 'Street/Square',
    number: 'Number',
    postcode: 'Postcode',
    city: 'City',
    state: 'State',
    country: 'Country',
    phone: 'Phone',
    note: 'Note',
    save: 'Save',
    taxNumber: 'Tax Number',
    taxNumberBracket: '(mandatory only for Italian citizens)',
    taxNumberMessage: 'The tax code does not correspond to the code of a physical person. If you are a private company, please contact support by email.',
  },
  password: {
    changePassword: 'Change password',
    old: 'Old password',
    new: 'New password',
    newConfirm: 'Confirm new password',
    savePassword: 'Save new password',
  },
  payments: {
    stripe: 'Credit Card',
    paypal: 'PayPal',
    'paypal-msg': 'You will be redirected to Paypal website',
    'stripe-msg': 'Processing Payment...',
    'sepa-msg': 'Processing Payment...',
    'sofort-msg': 'You will be redirected to Sofort website',
    sepa: 'Sepa Direct Debit',
    sofort: 'Sofort Banking',
    cash: 'Cash on Delivery',
  },
  shipping: {
    'shipping-to': 'Shipping To:',
    express: 'Express',
    standard: 'Standard',
    waiter: 'Waiter',
  },
  checkout: {
    header: 'Checkout',
    'billing-address': 'Billing Address',
    'shipping-address': 'Shipping Address',
    'shipping-addresses': 'Shipping Addresses',
    'first-name': 'First Name',
    'last-name': 'Last Name',
    email: 'Email',
    phone: 'Phone Number',
    country: 'Select a Country',
    city: 'City',
    address: 'Address',
    no: 'No.',
    zip: 'Zip code',
    'shipping-to': 'Ship To:',
    'payment-method': 'Payment Method:',
    summary: 'Summary',
    'order-btn': 'Complete Order',
    workingOn: 'Waiting for order creation ...',
    processing: 'Processing ...',
    'order-placed': 'Order has been placed',
    selectAddress: 'Select a shipping address:',
    changeAddress: 'Change selected address',
    addAddress: 'Add address',
    comeBack: 'Come back to checkout',
    'delay-message': 'If you choose this payment method, the delivery time may be longer. Before fulfilling the order we wait for the notification of successful payment (from 2 to 6 days).',
    'cash-message1': 'This payment method carries a fee of',
    'cash-message2': 'in addition to the order total.',
    commission: 'Fee',
    coupon: 'Coupon',
    'discounted-total': 'Discounted total',
    'discounted-subtotal': 'Discounted subtotal',
  },
  locale: {
    language: 'Language:',
  },
  catalog: {
    'view-all': 'View all',
    'search-acc': 'Search Accessories',
    'search-str': 'Search your string',
    octaves: 'Octaves',
    strings: 'Strings',
    brands: 'Brands',
    str: 'Strings',
    acc: 'Accessories',
    subcategory: 'Subcategory',
    brand: 'Brand',
  },
  menu: {
    'configurator-string': 'Strings Configurator',
    search: 'Search',
    account: 'My Account',
    cart: 'Cart',
    'shipping-locale': 'Change language',
  },
  login: {
    enter: 'Login',
    'pw-forgot': 'Forgot your password?',
    new: 'New Customer?',
    register: 'Register now',
    verify: 'Please verify your email address',
    welcome: 'Welcome back, ',
    logout: 'Log out',
  },
  signin: {
    title: 'Register or Login to Salvi Music',
    register: 'Register',
    login: 'Log in',
    firstname: 'Firstname',
    lastname: 'Lastname',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    receive: "Haven't received the email?",
    resend: 'Resend Email',
    vatsMessage: 'If you want to register on this site as legal persons (schools, associations, holders of VAT number) please contact us by writing to this address: ',
  },
  carousel: {
    title1: 'TRY THE NEW STRINGS CONFIGURATOR',
    title2: 'ALL THE ACCESSORIES FOR YOUR HARP',
    discover: 'Discover',
  },
  product: {
    vat: 'Includes VAT, Shipping excluded',
    shipping: 'Free Shipping',
    payment: 'Secure Payment',
    returns: 'Return & Refunds',
    details: 'Product Details',
    'shop-by': 'Shop By',
    brand: 'Brands',
    price: 'Price',
    shop: 'Shop',
    strings: 'Strings',
    string: 'Strings',
    accessories: 'Accessories',
    delivery: 'Shipping and Delivery',
    material: 'Material:',
    octave: 'Octave:',
    note: 'Note:',
    quantity: 'Quantity:',
    'orders-over': 'On orders over 150€',
    'free-delivery': 'Free delivery for purchases of at least 150€. Free shipping applies automatically as soon as the amount is reached.',
    addToCart: 'Add to cart',
    addedToCart: 'Product added to cart',
    alt: 'Image for',
    widget: 'Product card',
    addToCartOctave: 'Add octave to cart',
    addToCartLayout: 'Add strings layout to cart',
    searchingStrings: "You're looking through the strings: ",
    outOfStock: 'Out of stock',
    noVat: 'VAT excluded, Shipping excluded',
    notAvailable: 'Currently not available',
    categories: 'Categories',
    sheet: 'Sheet Music',
    cd: 'Recordings & CDs',
    onRequest: 'On request',
    onRequestMessage: 'Request this article by email with a simple click. At the moment it is not in stock, delivery time is extended (about 2 weeks).',
    onRequestAreYouSending: 'You are sending an order request for the product:',
  },
  string: {
    family: 'family:',
    material: 'material:',
    octave: 'octave:',
    note: 'note:',
  },
  orders: {
    number: 'order number',
    date: 'order date',
    amount: 'order amount',
    status: 'order status',
    'status-in_work': 'Working On It',
    'status-shipped': 'Shipped',
    'status-new': 'New',
    'status-registered': 'Registered',
    'status-pending': 'Pending',
    'status-failed_payment': 'Payment failed',
  },
  order: {
    details: 'order details',
    'invoice-link': 'View Invoice',
    'status-processed': '1. Processed',
    'status-transit': '2. In Transit',
    'status-delivered': '3. Delivered',
    number: 'Order number',
    date: 'Order date',
    'billing-address': 'Billed to',
    'shipping-address': 'Shipping address',
    'shipping-method': 'Shipping method',
    'payment-method': 'Payment method',
    summary: 'Summary',
    description: 'Description',
    code: 'Code',
    product: 'Product',
    qty: 'Quantity',
    amount: 'Amount',
    back: 'Back',
    subtotal: 'Subtotal',
    shipping: 'Shipping',
    total: 'Total',
    'inc-vat': 'incl. VAT',
    'tracking-info': 'Tracking information',
    'tracking-sentence': 'Check the status of your shipping ',
    'tracking-here': 'here',
    pending: 'Order pending payment.',
    pay: 'Pay',
    message: "If payment won't be made within one week, this order will be canceled.",
    noVat: 'excl. VAT',
    waitingConfirm: 'Waiting for payment confirmation',
  },
  configurator: {
    title: 'STRINGS CONFIGURATOR',
    subtitle: 'The fastest and easiest way to find your right string',
    chooseHarp: 'Choose a harp',
    selectOctave: 'Select octave',
    selectNote: 'Select note',
    selectMaterial: 'Select material',
    strings: 'Strings',
    seeMore: 'See more harps',
    seeYours: 'See your harps',
    octave: 'Octave',
    note: 'Note',
    description: 'Description',
    price: 'Price',
    reset: 'Reset configurator',
    lever: 'Lever harps',
    pedal: 'Pedal harps',
    electric: 'electric',
    electroacustic: 'electroacustic',
    'professional lever': 'Professional lever',
    'student lever': 'Student lever',
    premium: 'Premium',
    'professional pedal': 'Professional pedal',
    'student pedal': 'Student pedal',
    'lever gut': 'Lever Gut',
    'pedal gut': 'Pedal Gut',
    silkgut: 'Silkgut',
    biocarbon: 'BioCarbon',
    KF: 'Carbon',
    workInProgress: 'The strings configurator is work in progress',
    comeBack: "If you can't find your harp configuration, try coming back in a few days.",
  },
  footer: {
    terms: 'Terms and Conditions',
    shipping: 'Shipping and Payments',
    about: 'About',
    shop: 'Shop',
    contact: 'Contact',
    newsletter: 'Join to our newsletter',
    signup: 'Sign up',
    'customer-service': 'Customer Service',
    cookie: 'Cookie and Privacy Policy',
    'privacy-newsletter': "I've read the Privacy Policy and I authorize the use of my data for marketing purposes, included the newsletter.",
    'cookie-banner': '🍪 This website uses cookies. For more information click',
    'cookie-button': 'Got it!',
    here: 'here',
    logos: 'logos',
    socialLogos: 'social networks logos',
    paymentLogos: 'payment logos',
    email: 'Email',
    newsletterTitle: 'Newsletter',
    imprint: 'Imprint',
  },
  error: {
    404: 'Error 404',
    page: 'UH OH! You seem lost!',
    phrase: 'The page you are looking for does not exist. How you got here is a mystery. But you can click the button below to go back to the homepage.',
    503: 'Back soon!',
    'phrase-503': 'Sorry, the site is temporarily down for maintenance, but we will be back soon. Try again later!',
  },
  cart: {
    cart: 'Cart',
    clear: 'Clear cart',
    total: 'Total',
    subtotal: 'Subtotal',
    shippingCalculate: 'Shipping calculate at checkout',
    shipping: 'shipping',
    vat: 'Incl. VAT',
    checkout: 'Checkout',
    emptyCart: 'The cart is empty.',
    noVat: 'Excl. VAT',
    shippingNational: 'Price for national shipping',
    shippingAbroad: 'Price for international shipping',
    heavyShipping: 'The shipping price varies based on the weight of the selected items',
  },
  notifications: {
    error: 'There was an error:',
    failedReadingProduct: 'Failed reading of selected product:',
    credentialsInvalid: 'The given credentials are invalid.',
    successfulLogin: 'You are successfully logged in!',
    noMoreLoggedIn: 'You are no longer logged in!',
    changeLocale: 'Language setting error:',
    harpsReading: 'Harps reading failed',
    updateLocale: 'Language successfully updated',
    saveAddress: 'Address successfully saved',
    editAddress: 'Address successfully updated',
    removeAddress: 'Address successfully removed',
    addHarp: 'Harp successfully added',
    removeHarp: 'Harp successfully removed',
    updatePassword: 'Password successfully updated',
    registration: 'Registration successful',
    contact: 'Email successfully sent to info@salvimusic.de',
    chooseHarp: 'Please, select a harp',
    errorTryAgain: 'There was an error. Please try again',
    expiredSession: 'Expired session. Please log in',
    errorReload: 'There was an error. Please reload the page',
    errorPayment: 'There was a payment error, please try again',
    whyDiscount: 'You are entitled to this discount as a ',
    outOfStockFirst: 'The product',
    outOfStockSecond: 'has been removed from the cart because it is currently out of stock.',
    noStringsLayout: 'The requested strings layout is not yet available',
    emailSendAgain: 'We send you a new email',
    newsletterAccept: 'Please, accept the privacy policy',
    newsletterSend: 'We sent you an email to confirm the newsletter subscription',
    onRequestEmail: 'The request email has been sent',
  },
  contacts: {
    title: 'Contacts',
    'opening-hours': 'Opening hours:',
    showroomPhone: 'Phone:',
    showroomEmail: 'Email:',
    firstShowroom: {
      name: 'Remagen Showroom',
      address: 'Mainzer Straße, 28 - 53424 Remagen',
      time: 'Opening hours: Monday to Friday from 9:00 to 17:00',
      phone: 'Phone: 02228.8093',
      email: 'Email: info@salvimusic.de',
    },
    secondShowroom: {
      name: 'Berlin Showroom',
      address: 'Schloßstraße, 66 - 14059 Berlino',
      time: 'Opening hours: Monday to Friday from 9:30 to 17:30',
      phone: 'Phone: 030.37025222',
      email: 'Email: info@salvimusic.de',
    },
    contactUs: 'Contact us',
    firstname: 'Firstname',
    lastname: 'Lastname',
    email: 'Email',
    phone: 'Phone',
    message: 'Message',
    send: 'Send',
  },
  paginate: {
    previous: 'Previous',
    next: 'Next',
  },
  stripe: {
    data: 'Payment data',
    holder: 'Card holder',
    save: 'Save Payment Method',
    add: 'Add new card',
    enterPaymentMethod: 'Please select a payment method',
    authRequired: 'Authentication required to authorize payment',
    expiry: 'Expiry:',
    mine: 'My payment methods',
  },
  cards: {
    cards: 'My cards',
    areYouSure: 'Are you sure you want to delete this payment method?',
    irreversible: 'Irreversible operation',
    delete: 'Delete',
    cancel: 'Cancel',
    expired: 'EXPIRED!',
    last: 'your last payment method',
    seeAll: 'See all cards',
    close: 'Close',
  },
  iban: {
    seeAll: 'See all iban',
    close: 'Close',
    add: 'Add new iban',
    save: 'Save iban',

  },
  input: {
    fillField: 'Fill in this field',
  },
  metaDescriptions: {
    homepage: 'Welcome to Salvi Music Online SHOP, your online shopping destination for all kind of accessories and strings for your harp. We offer quality and precision at the best price.',
    about: 'Salvi Music Online SHOP serves beginner to professional harpists with commitment, service and product knowledge about their selection of lever and pedal harps, sheet music, strings and accessories.',
    configurator: 'Any string for your harp! With our fast and optimal system, the configurator will offer you everything you need with a simple click.',
    categoryCatalogs: 'In our catalogue you will find all the strings, for lever and pedal harps, of the best brands Bow Brand, Pirastro, Sipario, and all the accessories for your harp, transport covers, carts, sheet music, benches, stands, tuning keys and more...',
    brandCatalogs: 'We offer a complete catalogue for the entire Salvi Harps, Lyon & Healy, BownBrand and Sipario collection. Click here to find out more...',
    account: 'Make the most of your customer account options: check your order status, use your coupons, save and edit your details.',
    orders: 'Place easily your order, check your order status at any time with a simple click…',
    addresses: 'Billing and shipping address, easily manage your addresses, add, edit and delete…',
    coupons: 'Check here your coupons, surprising discounts just for you!',
    checkout: 'Your payment can be made safely and securely choosing your preferred method! Learn more…',
    singleOrder: 'In My Orders section you will be able to view your order summary, status of shipment and details, just providing your registration details.',
    terms: 'View the full terms and conditions for shopping on the Salvi Music Online SHOP, including payment, delivery, returns and more.',
    return: 'We are happy to exchange or refund any item(s) purchased within 30 days of the original purchase. Learn more…',
    shipping: 'It has never been so affordable! Only 2 EUR per shipment, free shipping for orders over 150 EUR.',
    contacts: 'Do you have a question or need help? Get in touch with us immediately. All around the Europe, within your reach. Find here our Salvi Music showrooms and contact details for the best support.',
  },
  productAttributes: {
    material: 'Material',
    octave: 'Octave',
    note: 'Note',
    silkgut: 'Silkgut',
    'silkgut copper': 'Silkgut Copper',
    biocarbon: 'BioCarbon',
    kf: 'KF',
    'lever gut': 'Lever gut',
    'pedal gut': 'Pedal gut',
    'lever wire': 'Lever wire',
    'pedal wire': 'Pedal wire',
    'lever nylon': 'Lever nylon',
    'pedal nylon': 'Pedal nylon',
    'polyester/polyurethane': 'Polyester/Polyurethane',
    velvet: 'Velvet',
    satin: 'Satin',
    'eco fabric': 'Eco Fabric',
    'steel/rubber': 'Steel / Rubber',
    leather: 'Leather',
    cordura: 'Cordura',
    wood: 'Wood',
    steel: 'Steel',
    polyester: 'Polyester',
    'leather, nylon': 'Leather, nylon',
    wire: 'Wire',
    alluminium: 'Alluminium',
    'nylon/polyurethane': 'Nylon/Polyurethane',
    'cotton/vinyl': 'Cotton / Vinyl',
    felt: 'Felt',
  },
  coupons: {
    apply: 'Apply',
    validCode: 'valid code',
    noSelected: 'No coupon selected',
    hasACoupon: 'Do you have a coupon?',
    invalid: 'The coupon entered is not valid or has already been used',
    code: 'Code',
    description: 'Description',
    value: 'Value',
    uses: 'Number of uses',
    expiration: 'Expiration Date',
    exhaustion: 'until exhaustion',
    used: 'Coupon used',
    subtotalWithoutCoupon: 'Subtotal without coupon',
    subtotalDiscounted: 'Discounted Subtotal',
    writeCoupon: 'Write the coupon code:',
    chooseCoupon: 'Or select one of your coupons:',
    expired: 'Expired',
    noCoupons: 'Currently you have no coupons.',
  },
  filters: {
    clear: 'Clear filters',
    brand: 'Brand',
    subcategory: 'Subcategory',
    noProducts: 'There are no products with these characteristics.',
    noComposers: 'There are no composers with this initial.',
    searchComposer: 'Search composer',
  },
};
